import type { IMe } from '@platform/core/types';
import { canQueryPii } from '../fields/canQueryPii';

/**
 * Хто може повторно призначити чинного виконавця в чернетці запису (рішення 1 етапу 10, isReassignment): ідентифікатор поточного
 * користувача, якщо він Owner/Admin простору `ws` (адміністратор платформи поза членством — Admin; сесія спостерігача — ні) — та сама
 * роль, що відкриває запити за персональними даними (canQueryPii); інакше — undefined. Чиста функція.
 */
export function reassignerOf(me: Pick<IMe, 'id' | 'globalRole' | 'workspaces'> | undefined, ws: string, observer: boolean): string | undefined {
  return me && canQueryPii(me, ws, observer) ? me.id : undefined;
}
